import ax from '../axios'
import {API_URL} from "../index";

const HOMEWORK_SESSION_URL = API_URL.EDUCATION_MODULE + '/homework-session'

const getHomeworkSession = (query: string) => {
    return ax.get(`${HOMEWORK_SESSION_URL}?${query}`)
}
export {
    getHomeworkSession,
}
